import axios from "axios";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

const definitionPayload = (values = {}) => {
  const payload = { ...values };
  delete payload["id"];
  delete payload["salon_id"];
  delete payload["auth_key"];
  delete payload["action"];
  return payload;
};

const create = (values) =>
  axios.post(
    API_URL + "afterlogin/discount-code/store",
    definitionPayload(values),
    { headers: authHeader() },
  );

const update = (values) =>
  axios.post(
    API_URL + `afterlogin/discount-code/update/${values.id}`,
    definitionPayload(values),
    { headers: authHeader() },
  );

const view = (values = {}) =>
  axios.post(
    API_URL + "afterlogin/discount-code/view",
    values.id ? { id: values.id } : { include_inactive: values.include_inactive === true },
    { headers: authHeader() },
  );

const deleted = (values) =>
  axios.post(
    API_URL + `afterlogin/discount-code/delete/${values.id}`,
    {},
    { headers: authHeader() },
  );

const discountCodeApiController = { create, update, view, deleted };

export default discountCodeApiController;
